import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { Image } from "../../../components/Image";
import { Link } from "../../../components/Link";
import { IProduct } from "../../../models/catalogue";

import styles from "./common.module.scss";

export const BasketLineImage = (
    props: Immutable<{
        product: IProduct;
    }>,
): React.ReactNode => {
    // Use the product image if one exists else try the parent image
    let image = props.product.images.slice().shift();
    if (!image && props.product.parent) {
        image = props.product.parent.images.slice().shift();
    }
    if (!image) {
        return null;
    }

    // Prefer the variant's own link (which includes the `/v/{id}/` suffix so
    // the PDP lands on the correct variant), falling back to the parent's link.
    const productLink =
        props.product.link ??
        (props.product.parent ? props.product.parent.link : null);

    // Refs #22223 - Prevents rendering multiple link wrappers to the same location
    // to avoid ADA issues. If a link exists, renders image link wrapper.
    if (productLink) {
        return (
            <Link className={styles.link} href={productLink} target="_top">
                <Image
                    className={styles.image}
                    alt={t`Learn more about ${props.product.title}`}
                    src={image.original}
                />
            </Link>
        );
    }

    return (
        <div className={styles.link}>
            <Image className={styles.image} alt="" src={image.original} />
        </div>
    );
};
